import styled from 'styled-components'
import { Table } from 'antd'

export const StyledApprovalTable = styled(Table)`
  width: 100%;
  .ant-table {
    background: #ffffff;
    width: 100%;
  }
  .ant-table-container,
  .ant-table-content {
    width: 100%;
    overflow-x: auto;
  }
  .ant-table-thead > tr > th::before,
  .ant-table-thead > tr > th::after {
    display: none !important;
    content: none !important;
  }

  .ant-table,
  .ant-table-container,
  .ant-table-content,
  .ant-table-thead,
  .ant-table-tbody,
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    border-radius: 0 !important;
  }

  .ant-table-thead > tr > th {
    background: white;
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #8c8c8c;
    border: 1px solid #e5e5e5;
  }

  .ant-table-tbody > tr > td {
    height: 70px;
    border: 1px solid #e5e5e5;
    font-size: 13px;
    white-space: normal;
    word-break: break-word;
  }

  .ant-table-tbody > tr:hover > td {
    background: #ffffff;
  }

  .ant-table-pagination {
    margin-top: 16px;
    display: flex;
    justify-content: center;
    text-align: center;
  }

  .ant-table-selection-column {
    padding-left: 16px !important;
    padding-right: 16px !important;
    width: 56px;
  }
`

export const Wrapper = styled.div`
  padding: 0;
`

export const Card = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 20px;
`

export const Title = styled.h2`
  margin: 0;
  font-size: 20px;
`

export const Subtitle = styled.p`
  margin-top: 4px;
  color: #777;
`

export const Divider = styled.div`
  height: 1px;
  background: #e5e5e5;
  margin: 24px 0 24px 0;
`

export const BulkRow = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  padding: 10px 0;
  color: #999FAC;
    .bulk-label {
    font-family: 'Plus Jakarta Sans';
    font-style: semibold;
    margin-left: 30px;
    font-weight: 600;
  }
`

export const TableHeaderRow = styled.div`
  display: grid;
  grid-template-columns: 5fr 2fr 2fr;
  border: 1px solid #e5e5e5;
  border-bottom: none;
    &:last-child {
    border-bottom: none;
  }
`

export const HeaderCell = styled.div`
  padding: 10px 12px;
  border-right: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  color: #323538;
    &:last-child {
    border-right: none;
    border-bottom: none;
  }
  }
`

export const ShowingText = styled.span`
  color: #3235385e !important;
  font-weight: 400;
`